import {trackEvent} from 'analytics/Analytics';
import {LLM_CHAT_ANALYTICS_ACTIONS} from 'constants/analytics-products/LLMChatConstants';
import * as NavConstants from 'constants/NavConstants';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ChatDraftStatus, createChat, setDraftMessage} from 'llm/chat-library/ChatActions';
import {CreateChatOptions} from 'llm/chat-library/ChatDAO';
import {openExistingChat} from 'llm/chat-library/sidepanel/AISidepanelV2GlobalClientState';
import {getChatTypeForNewAgentChat} from 'llm/chat-library/sidepanel/ChatTypeUtil';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';

/**
 * Creates a new chat for an entry and opens the AI sidepanel in semi-expanded mode.
 */
export default async function createChatForEntry(entryId: string, agentType: AgentType): Promise<void> {
  const chatType = getChatTypeForNewAgentChat(agentType);
  const createOptions: CreateChatOptions = {};
  if (agentType === AgentType.DATA_CAPTURE) {
    createOptions[AgentType.DATA_CAPTURE] = {targetEntryId: entryId};
  } else if (agentType === AgentType.ANALYSIS) {
    createOptions[AgentType.ANALYSIS] = {targetEntryId: entryId};
  }
  const {chatSessionId} = await createChat(chatType, createOptions, agentType);
  trackEvent(LLM_CHAT_ANALYTICS_ACTIONS.CREATED_CHAT_FOR_ENTRY, {
    agentType,
    entryId,
    chatSessionId,
  });
  setDraftMessage(chatSessionId, {
    status: ChatDraftStatus.DRAFT,
    message: {text: '', selectedFiles: []},
    settings: {agentType, publicDataEnabled: false},
  });
  openExistingChat(chatSessionId);
  SidepanelActions.openSection(NavConstants.SECTIONS.AI);
}
